import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const LeaderContent = styled.div`
    display: flex;
    flex-direction: column;

    > * {
        flex: 1;
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.gaps.large}
        flex-direction: row;
    }
`;

export const LeaderListContainer = styled.ul`
    ${BaseStyle.Mixins.gaps.small};
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding-bottom: 8px;
    padding-top: 12px;
    text-align: right;
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.medium} {
        padding-bottom: 12px;
        padding-top: 26px;
    }
`;

export const LeaderListItem = styled.button`
    ${BaseStyle.Mixins.fontStyles.ui['14m']};
    ${BaseStyle.Mixins.gaps.semiMedium};
    border: solid 1px ${({ theme }) => theme.Surface.border};
    border-radius: 8px;
    height: 40px;
    padding: 7px 12px;
    text-align: left;

    display: flex;
    align-items: center;

    ${BaseStyle.Mixins.screenSizes.medium} {
        height: 28px;
    }

    &.active {
        background-color: ${({ theme }) => theme.Utility.cta};
        border: none;

        span {
            color: ${({ theme }) => theme.Text.OppositeSurface.primary};
        }
    }
`;

export const LeaderListRank = styled.span`
    width: 24px;
`;

export const LeaderListName = styled.span`
    flex: 1;
`;

export const LeaderListValue = styled.span`
    text-align: right;
`;

export const NoDataMessage = styled.p`
    ${BaseStyle.Mixins.fontStyles.ui['14b']};
    padding: 32px 0;
`;

export const LeadersNavLink = styled(NavLink)`
    ${BaseStyle.Mixins.fontStyles.ui['16m']};
    display: flex;
    justify-content: end;
    padding-top: 8px;

    && {
        color: ${({ theme }) => theme.Utility.cta};

        &:hover {
            color: ${({ theme }) => theme.Utility.cta};
        }
    }
`;
